import { render, staticRenderFns } from "./AccountEditAddress.vue?vue&type=template&id=1989f97e&scoped=true&"
import script from "./AccountEditAddress.vue?vue&type=script&lang=js&"
export * from "./AccountEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989f97e",
  null
  
)

export default component.exports